/* eslint-disable indent */
import {
    AlphabeticalSortCommand,
    Command,
    NewestSortCommand,
    PopularitySortCommand,
    PriceSortCommand,
    ReviewSortCommand,
    SearchSortCommand,
    SmokeSortCommand,
} from '../../commands';

export class SortFactory {
    static createCommand(sortType: string): Command {
        switch (sortType) {
            case 'sort':
                return new SmokeSortCommand();
            case 'alphabetical':
                return new AlphabeticalSortCommand();
            case 'newest':
                return new NewestSortCommand();
            case 'popular':
                return new PopularitySortCommand();
            case 'price':
                return new PriceSortCommand();
            case 'review':
                return new ReviewSortCommand();
            case 'relevance':
                return new SearchSortCommand();
            default:
                throw new Error(`Invalid sort command type: ${sortType}`);
        }
    }
}
